import { getAllProgrammeStats, getIndexSummaryStats, getSingleProgrammeStats } from "../../api";

var cachedProgrammeStats = [],
    cachedSingleProgrammeStats = [],
    cachedIndexSummaryStats = [];

export const getCachedAllProgrammeStats = async (playerId) =>
{
    if (cachedProgrammeStats[playerId])
    {
        console.log('fromcache', playerId, cachedProgrammeStats[playerId]);
        return cachedProgrammeStats[playerId];
    }
    const result = await getAllProgrammeStats(playerId);
    cachedProgrammeStats[playerId] = result;
    console.log('tocache', playerId)
    return result;
}

export const getCachedSingleProgrammeStats = async (playerId, programmeId) =>
{
    if (cachedSingleProgrammeStats[playerId] && cachedSingleProgrammeStats[playerId][programmeId])
    {
        console.log('fromcache', playerId, programmeId, cachedSingleProgrammeStats[playerId][programmeId]);
        return cachedSingleProgrammeStats[playerId][programmeId];
    }
    const result = await getSingleProgrammeStats(playerId, programmeId);
    if (!cachedSingleProgrammeStats[playerId])
    {
        cachedSingleProgrammeStats[playerId] = [];
    }
    cachedSingleProgrammeStats[playerId][programmeId] = result;
    console.log('tocache', playerId, programmeId)
    console.log(cachedSingleProgrammeStats)
    return result;
}

export const getCacheIndexSummaryStats = async (playerId) =>
{
    if (cachedIndexSummaryStats[playerId])
    {
        console.log('fromcache iss', playerId, cachedIndexSummaryStats[playerId]);
        return cachedIndexSummaryStats[playerId];
    }
    const result = await getIndexSummaryStats(playerId);
    cachedIndexSummaryStats[playerId] = result;
    console.log('tocache iss', playerId)
    return result;
}